import axios from "axios";

import { BASE_URL } from "src/shared/model";
import { authModel } from "src/entities/auth";
import { store } from "src/app/model";

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 422)
    ) {
      localStorage.removeItem("token");
      store.dispatch(authModel.actions.setIsAuth(false));
    }
    return Promise.reject(error);
  },
);
